<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs  {{
		sectionclass
	}}"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="reach-freq-widget-header">
		<div class="campaignNameHeader">{{ sectiontitle }}</div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="hasData && downloadConfiguration && downloadConfiguration.enableDownload"
			(click)="downloadCSV()"
			target="_blank"
		>
			<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
		</a>
	</div>
	<div *ngIf="hasData">
		<ngu-carousel #carousel [inputs]="carouselOne" (carouselLoad)="initDataFn($event)" [dataSource]="campaignsList">
			<ngu-tile NguCarouselItem class="col-xl-12" *nguCarouselDef="let campaign; let i = index">
				<div class="date-range-banner date-range-banner-above-title" *ngIf="campaign.showBanner" style="display: none">
					<div class="banner-content">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
							style="margin-right: 8px; flex-shrink: 0"
						>
							<path
								d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
								fill="#00AAFF"
							/>
							<path
								d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
								fill="#00AAFF"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
								fill="#00AAFF"
							/>
						</svg>
						<div class="banner-text">
							Some reach and frequency values may be incomplete due to historical data limits (only past 2 years + 1
							quarter available)
						</div>
					</div>
				</div>
				<div class="stats-container">
					<div *ngIf="!isR104" class="campaigns-toggle">
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="previous-arrow"
									(click)="prevArrow()"
									src="../../../../../assets/images/chevron-left-large.png"
								/>
							</a>
						</div>
						<div class="campaign-name">
							<p>{{ campaign.name }}</p>
						</div>
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="next-arrow"
									(click)="nextArrow()"
									src="../../../../../assets/images/chevron-right-large.svg"
								/>
							</a>
						</div>
					</div>
					<div *ngIf="isR104" class="campaigns-toggle">
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="previous-arrow"
									(click)="prevArrow()"
									src="../../../../../assets/creative-assets/arrow-left-r104.svg"
								/>
							</a>
						</div>
						<div class="campaign-name">
							<p>{{ campaign.name }}</p>
						</div>
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="next-arrow"
									(click)="nextArrow()"
									src="../../../../../assets/creative-assets/arrow-right-r104.svg"
								/>
							</a>
						</div>
					</div>

					<div class="campaign-content">
						<div class="date-range-banner" *ngIf="campaign.showBanner">
							<div class="banner-content">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="14"
									height="14"
									viewBox="0 0 14 14"
									fill="none"
									style="margin-right: 8px; flex-shrink: 0"
								>
									<path
										d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
										fill="#00AAFF"
									/>
									<path
										d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
										fill="#00AAFF"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
										fill="#00AAFF"
									/>
								</svg>
								<div class="banner-text">
									Some reach and frequency values may be incomplete due to historical data limits (only past 2 years + 1
									quarter available)
								</div>
							</div>
						</div>
						<div class="campaign-data" [ngClass]="{ 'r4-loader-mask': showLoad }">
							<div class="lifetime-average">
								<div class="lifetime-average-title">Lifetime Campaign Average</div>

								<div *ngFor="let avg of campaign.averageLifetimes">
									<div class="lifetime-average-metric">
										<div class="metric-title">
											{{ avg.parameterName }}
										</div>
										<div class="metric-value" [ngClass]="{ 'normal-font-weight': avg.isNonZeroValue }">
											{{ avg.parameterValue }}
										</div>
									</div>
								</div>
							</div>
							<div class="lifetime-chart">
								<div class="date-range-banner r6-date-range-banner" *ngIf="campaign.showBanner" style="display: none">
									<div class="banner-content">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="14"
											height="14"
											viewBox="0 0 14 14"
											fill="none"
											style="margin-right: 8px; flex-shrink: 0"
										>
											<path
												d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
												fill="#00AAFF"
											/>
											<path
												d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
												fill="#00AAFF"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
												fill="#00AAFF"
											/>
										</svg>
										<div class="banner-text">
											Some reach and frequency values may be incomplete due to historical data limits (only past 2 years
											+ 1 quarter available)
										</div>
									</div>
								</div>
								<div *ngIf="campaign.showChart; else elseBlockHideChart" class="" style="min-height: 200px">
									<app-chart
										class="individual-chart"
										[setcolor]="customchartconfiguration.setGraphBackgroundColor"
										[chartData]="campaignCarouselItem"
									></app-chart>
								</div>
								<ng-template #elseBlockHideChart>
									<div class="individual-chart no-data">
										<p class="no-data-selected-date">{{ nodatamessage }}</p>
									</div>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</ngu-tile>
			<ul class="myPoint" NguCarouselPoint>
				<li
					*ngFor="let j of carousel.pointNumbers; let k = index"
					[class.primary-color-bg]="j == carousel.activePoint"
					(click)="moveToSelected(k)"
					[style.background]="'url(' + campaignsList[k] + ')'"
				></li>
			</ul>
		</ngu-carousel>
	</div>
	<div *ngIf="!hasData" class="no-reach-frequency">
		<div class="no-data-text">{{ nodatamessage }}</div>
	</div>
</div>
